"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/* eslint-disable no-unused-expressions */
var component_fields_1 = require("@doordash/component-fields");
var React = __importStar(require("react"));
var LayoutContext_1 = require("../../Common/LayoutContext");
var isMobile_1 = require("../../Common/utils/isMobile");
var index_1 = require("../../index");
var TwoFactorAuthenticationStrings_1 = __importDefault(require("../TwoFactorAuthenticationStrings"));
var VerifyAccountTracking_1 = require("../VerifyAccountTracking");
var EnterCode = function (_a) {
    var clearError = _a.clearError, verifyCode = _a.verifyCode, verifyError = _a.verifyError;
    var _b = React.useContext(index_1.RiskContext), dispatch = _b.dispatch, state = _b.state;
    var _c = React.useContext(LayoutContext_1.LayoutContext), primaryAction = _c.primaryAction, setPrimaryAction = _c.setPrimaryAction;
    var _d = __read(React.useState(''), 2), code = _d[0], setCode = _d[1];
    var _e = __read(React.useState(false), 2), error = _e[0], setError = _e[1];
    // tslint:disable max-line-length
    /*
    This handle focus is in order to get the NumberField to scroll into view when
    it is focused on. The event persist is to handle how React deal with synthetic events.
    The setTimeout is in place to handle the race condition of the iOS resizing window
    so that the submit button appears in the right place.
    */
    var windowResizingTimer = 500;
    var handleFocus = function (evt) {
        var target = evt.target;
        setTimeout(function () {
            if (target) {
                target.scrollIntoView();
            }
        }, windowResizingTimer);
    };
    React.useEffect(function () {
        if (primaryAction.isSubmitting) {
            VerifyAccountTracking_1.trackOnClick(state.workflow);
            verifyCode(code).then(function () {
                VerifyAccountTracking_1.trackOnSuccess(state.workflow);
                dispatch({ type: index_1.RiskActions.Reset });
                if (state.onSuccess) {
                    state.onSuccess();
                }
            });
        }
    }, [primaryAction.isSubmitting]);
    React.useEffect(function () {
        setPrimaryAction({ isDisabled: !code });
    }, [code]);
    React.useEffect(function () {
        if (clearError) {
            setError(false);
            setCode('');
        }
    }, [clearError]);
    React.useEffect(function () {
        if (verifyError) {
            setError(!!verifyError);
        }
    }, [verifyError]);
    return (React.createElement(component_fields_1.NumberField, { onFocus: handleFocus, label: TwoFactorAuthenticationStrings_1["default"].enterCode(), value: code, error: error, onChange: function (value) { return setCode(value); }, size: isMobile_1.isMobile() ? component_fields_1.TextField.Sizes.Large : component_fields_1.TextField.Sizes.Medium }));
};
exports["default"] = EnterCode;
